var _style, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 5,
    className: "st0",
    width: 3,
    height: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 5,
    className: "st0",
    width: 3,
    height: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.7,
    y: 5,
    className: "st0",
    width: 3,
    height: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    className: "st0",
    width: 3,
    height: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenWall);
export default __webpack_public_path__ + "static/media/open-wall.028bb3d1f6cbb22951295597ff749618.svg";
export { ForwardRef as ReactComponent };